export const billingProfileHc = {
  datosFacturacion: {
    titulo: "Dados de faturamento",
    requeridos: "Os dados de faturamento são obrigatórios",
  },
  perfil: {
    swalTitle: "Verifique seu e-mail",
    swalText:
      "Para continuar com a alteração de senha, verifique sua caixa de entrada e siga os passos",
    swalConfirm: "Continuar",
    errorInesperado: "Ops! Ocorreu um erro inesperado",
  },
  facturacionCuenta: {
    editarInfo: "Editar informações",
    direccionLinea1: "Endereço linha 1",
    direccionLinea2: "Endereço linha 2 (opcional)",
    cancelar: "Cancelar",
    guardando: "Salvando...",
    guardarCambios: "Salvar alterações",
    errorCargar: "Erro ao carregar os dados de faturamento",
    actualizadoOk: "Dados atualizados com sucesso",
    errorActualizar: "Erro ao atualizar",
    errorActualizarDatos: "Erro ao atualizar os dados",
  },
};
